import { AbstractControl, ValidatorFn } from '@angular/forms';

import { createValidationError, hasNoValue } from '../../util';
import { fileSizeAllowed } from './file-size-allowed';
import { fileTypeAllowed } from './file-type-allowed';

export class FileUploadValidators {
  static fileSize(maxSize: number): ValidatorFn {
    function fileSizeValidator(control: AbstractControl) {
      const selectedFile = control.value as File;

      return hasNoValue(selectedFile) || fileSizeAllowed(selectedFile, maxSize)
        ? null
        : createValidationError('fileSize', 'fileUpload.maxFileSize.error');
    }

    return fileSizeValidator;
  }

  static allowFiles(allowedFiles: string[]): ValidatorFn {
    function allowFilesValidator(control: AbstractControl) {
      const selectedFile = control.value as File;
      return hasNoValue(selectedFile) || fileTypeAllowed(selectedFile, allowedFiles)
        ? null
        : createValidationError('allowFiles', 'fileUpload.allowFiles.error');
    }

    return allowFilesValidator;
  }
}
